export enum FormatLanguageEnum {
  DEFAULT = "default",
  TITLE_CASE = "title_case",
  UPPERCASE = "uppercase",
  LOWERCASE = "lowercase",
  REGIONAL_UPPERCASE = "regional_uppercase",
  REGIONAL_LOWERCASE = "regional_lowercase",
}
